// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statusCard {
    width: 100%;
    height: 150px !important;
    border-radius: 16px;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
    position: relative;
}

.statusCard .statusIcon {
    width: 80px;
    height: 80px;
    position: absolute;
    top: 20%;
    right: 2%;
    opacity: 0.08;
}
.statusCard.total-card{
    border: 2px solid transparent !important;
    background: 
    linear-gradient(#fff, #fff) padding-box,   /* Inner background */
    linear-gradient(-90deg, #231444, #4285F4) border-box; /* Border gradient */
}
.statusCard.defaultCard {
    border: 2px solid transparent !important;
    background: 
    linear-gradient(#fff, #fff) padding-box,   /* Inner background */
    linear-gradient(-90deg, #FAD961, #FFC5C0) border-box; /* Border gradient */
}

.statusCard.pending-card {
    border: 2px solid transparent !important;
    background: 
    linear-gradient(#fff, #fff) padding-box,   /* Inner background */
    linear-gradient(-90deg, #FAD961, #FFC5C0) border-box; /* Border gradient */
}

.statusCard.published-card {
    border: 2px solid transparent !important;
    background: 
    linear-gradient(#fff, #fff) padding-box,   /* Inner background */
    linear-gradient(-90deg, #7DCE13, #417505) border-box; /* Border gradient */
}
.statusCard.rejected-card {
     border: 2px solid transparent !important;
    background: 
    linear-gradient(#fff, #fff) padding-box,   /* Inner background */
    linear-gradient(-90deg, #EA4335, #E97970) border-box; /* Border gradient */
}`, "",{"version":3,"sources":["webpack://./src/component/shared/cards/StatusCard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;AACjB;AACA;IACI,wCAAwC;IACxC;;wDAEoD,EAAE,oBAAoB;AAC9E;AACA;IACI,wCAAwC;IACxC;;wDAEoD,EAAE,oBAAoB;AAC9E;;AAEA;IACI,wCAAwC;IACxC;;wDAEoD,EAAE,oBAAoB;AAC9E;;AAEA;IACI,wCAAwC;IACxC;;wDAEoD,EAAE,oBAAoB;AAC9E;AACA;KACK,wCAAwC;IACzC;;wDAEoD,EAAE,oBAAoB;AAC9E","sourcesContent":[".statusCard {\n    width: 100%;\n    height: 150px !important;\n    border-radius: 16px;\n    overflow: hidden;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);\n    position: relative;\n}\n\n.statusCard .statusIcon {\n    width: 80px;\n    height: 80px;\n    position: absolute;\n    top: 20%;\n    right: 2%;\n    opacity: 0.08;\n}\n.statusCard.total-card{\n    border: 2px solid transparent !important;\n    background: \n    linear-gradient(#fff, #fff) padding-box,   /* Inner background */\n    linear-gradient(-90deg, #231444, #4285F4) border-box; /* Border gradient */\n}\n.statusCard.defaultCard {\n    border: 2px solid transparent !important;\n    background: \n    linear-gradient(#fff, #fff) padding-box,   /* Inner background */\n    linear-gradient(-90deg, #FAD961, #FFC5C0) border-box; /* Border gradient */\n}\n\n.statusCard.pending-card {\n    border: 2px solid transparent !important;\n    background: \n    linear-gradient(#fff, #fff) padding-box,   /* Inner background */\n    linear-gradient(-90deg, #FAD961, #FFC5C0) border-box; /* Border gradient */\n}\n\n.statusCard.published-card {\n    border: 2px solid transparent !important;\n    background: \n    linear-gradient(#fff, #fff) padding-box,   /* Inner background */\n    linear-gradient(-90deg, #7DCE13, #417505) border-box; /* Border gradient */\n}\n.statusCard.rejected-card {\n     border: 2px solid transparent !important;\n    background: \n    linear-gradient(#fff, #fff) padding-box,   /* Inner background */\n    linear-gradient(-90deg, #EA4335, #E97970) border-box; /* Border gradient */\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
